import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials, TESTIMONIALS_NOTE } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-268" data-mp="3fzdzvmnrkjqe">
      <h2 id="testimonios" className="font-display text-xl md:text-2xl font-extrabold uppercase text-ink" data-id="element-269" data-mp="3b1ch72u92mfg">
        Lo que dicen quienes ya empezaron
      </h2>
      <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-270" data-mp="31zd3okig20h9">
        {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-271" data-mp="2x005x4q1b8zw" data-mpi={i}>
            <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-272" data-mp="v9oojjm9rg2g">
              {Array.from({
            length: 5
          }).map((_, j) => <StarIcon key={j} size={14} className="fill-accent text-accent" data-id="element-273" data-mp="qav9hmrc3h06" data-mpi={j} />)}
            </div>
            <blockquote className="mt-3 text-base leading-relaxed text-ink" data-id="element-274" data-mp="m5sysg0nlynm">
              “{t.quote}”
            </blockquote>
            <footer className="mt-auto pt-4 text-sm" data-id="element-275" data-mp="79v6x9xrjgh7">
              <span className="font-semibold text-ink" data-id="element-276" data-mp="c6252gjx3nol">{t.author}</span>
              <span className="text-ink-subtle" data-id="element-277" data-mp="zwponz3741qz"> — {t.location}</span>
            </footer>
          </Reveal>)}
      </ul>
      <p className="mt-3 text-xs italic text-ink-subtle" data-id="element-278" data-mp="14vsmayguj5ox">
        {TESTIMONIALS_NOTE}
      </p>
    </section>;
}